import {
	MESApiService,
	type spParameter,
} from "../../../../services/ApiService";
import { Profile } from "../../profiles/models/Profile";
import { Action } from "../models/Action";

//fx obtener profiles
export const getProfiles = async () => {
	const apiService = new MESApiService();
	const resp = await apiService.callV2("[SEC].[GetProfiles]", []);
	return resp;
};

export const upsertProfile = async (ProfileId: number, ProfileName: string) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [];

	parameters.push({ name: "ProfileId", value: ProfileId });
	parameters.push({ name: "ProfileName", value: ProfileName });

	const resp = await apiService.callV2("[SEC].[UpsertProfile]", parameters);
	return resp;
};

// PROFILES PROCEDURES
export const getActions = async () => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [];

	const resp = await apiService.callV2("[SEC].[GetActions]", parameters);
	return resp;
};

export const getActionsByProfileId = async (profile: Profile) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [];

	parameters.push({ name: "ProfileId", value: profile.ProfileId });

	const resp = await apiService.callV2(
		"[SEC].[GetActionsByProfileId]",
		parameters,
	);
	return resp;
};

export const upsertProfileActions = async (
	profile: Profile,
	actions: Action[],
) => {
	const apiService = new MESApiService();

	const actionsIds = actions.map((item) => item.ActionId);
	const actionIdsString = actionsIds.join(",");

	const parameters: spParameter[] = [];
	parameters.push({ name: "ProfileId", value: profile.ProfileId });
	parameters.push({ name: "ActionIds", value: actionIdsString });

	const resp = await apiService.callV2(
		"[SEC].[UpsertProfileActions]",
		parameters,
	);
	return resp;
};
//fx setear profiles de un profile

// fx eliminar profile
export const deleteProfile = async (profileId: number) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [];

	parameters.push({ name: "ProfileId", value: profileId });
	const resp = await apiService.callV2("[SEC].[DeleteProfile]", parameters);
	return resp;
};
